module.exports = __webpack_public_path__ + "static/img/pic.443bc692.jpg";